// extracted by mini-css-extract-plugin
export var hidden = "_6z-1";
export var visible = "_6z-0";